import { useState } from "react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import { useNavigate } from "react-router-dom";
import SessionStorageHelper from "../../utils/sessionStorageHelper";
import "../../styles/globals.css";

const Genderpage = () => {
  const [selected, setSelected] = useState<string>("");
  const navigate = useNavigate();

  const handleNext = () => {
    if (selected) {
      SessionStorageHelper.saveField("gender", selected.toLowerCase());
      navigate("/glucera" + GluceraNavigationRoutes.RACE_PAGE);
    }
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header with Progress */}
        <div className="space-y-4 p-4">
          {/* <button
            onClick={handleBack}
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-muted/80 transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button> */}

          {/* Logo */}
          <div className="flex items-center justify-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-orange-400">
              <svg
                className="h-5 w-5 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-5h2v2h-2zm0-8h2v6h-2z" />
              </svg>
            </div>
            <span className="text-lg font-semibold text-slate-500">
              Bite Balance
            </span>
          </div>

          {/* Assessment Progress */}
          <p className="text-center text-sm text-muted-foreground">
            Assessment 1 of 12
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-4 py-2 sm:px-6 sm:py-4">
          <div className="mb-4 space-y-1 sm:mb-6 sm:space-y-2">
            <h1 className="text-2xl font-bold text-foreground sm:text-3xl">
              What Is Your Gender?
            </h1>
            <p className="text-xs text-muted-foreground sm:text-sm">
              Gender Affects Diabetes Management
            </p>
          </div>

          {/* Options - Responsive spacing for content height */}
          <div className="mb-6 space-y-3">
            {["Male", "Female", "Other"].map(option => (
              <Card
                key={option}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selected === option
                    ? "border-2 border-primary bg-primary/5"
                    : "border-2 border-border hover:border-primary/50"
                }`}
                onClick={() => setSelected(option)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-lg font-semibold">{option}</span>
                  <div
                    className={`flex h-6 w-6 items-center justify-center rounded-full border-2 ${
                      selected === option
                        ? "border-primary bg-primary"
                        : "border-muted-foreground"
                    }`}
                  >
                    {selected === option && (
                      <div className="h-3 w-3 rounded-full bg-primary-foreground" />
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Button Container - Fixed position */}
          <div className="mt-auto">
            <Button
              onClick={handleNext}
              disabled={!selected}
              className="h-11 w-full rounded-xl bg-gradient-primary text-sm hover:opacity-90 disabled:opacity-50 sm:h-12 sm:text-base"
            >
              {selected ? "Next" : "Select Gender"}
            </Button>
          </div>
        </div>

        {/* Safe area padding for mobile */}
        <div className="pb-safe p-4 sm:pb-6" />
      </div>
    </div>
  );
};

export default Genderpage;
